// Lazy load function
const lazyLoad = (file) => () =>
  import(/* webpackChunkName: "[request]" */ `@/views/suppliers/${file}.vue`);

export default [
  {
    path: "/supplier",
    name: "supplier-list",
    meta: { requiresAuth: true, applicationFeatureCode: "Supplier" },
    components: {
      content: lazyLoad("supplier-list"),
    },
  },
  {
    path: "/supplier/create",
    name: "supplier-detail-create",
    meta: { requiresAuth: true, applicationFeatureCode: "Supplier" },
    components: {
      content: lazyLoad("supplier-detail"),
    },
  },
  {
    path: "/supplier/review/:id",
    name: "supplier-detail-review",
    meta: { requiresAuth: true, applicationFeatureCode: "Supplier" },
    components: {
      content: lazyLoad("supplier-detail"),
    },
  },
  {
    path: "/supplier/edit/:id",
    name: "supplier-detail-edit",
    meta: { requiresAuth: true, applicationFeatureCode: "Supplier" },
    components: {
      content: lazyLoad("supplier-detail"),
    },
  },

  {
    path: "/supplier-contact/:id",
    name: "supplier-contact",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "SupplierContact",
    },
    components: {
      content: lazyLoad("supplier-contact"),
    },
  },
  {
    path: "/supplier-contact/create/:id",
    name: "supplier-contact-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "SupplierContact",
    },
    components: {
      content: lazyLoad("supplier-contact"),
    },
  },
  {
    path: "/supplier-contact/review/:id",
    name: "supplier-contact-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "SupplierContact",
    },
    components: {
      content: lazyLoad("supplier-contact"),
    },
  },
  {
    path: "/supplier-contact/edit/:id",
    name: "supplier-contact-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "SupplierContact",
    },
    components: {
      content: lazyLoad("supplier-contact"),
    },
  },

  {
    path: "/supplier-note/:id",
    name: "supplier-note",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "SupplierNote",
    },
    components: {
      content: lazyLoad("supplier-note"),
    },
  },
  {
    path: "/supplier-note/create/:id",
    name: "supplier-note-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "SupplierNote",
    },
    components: {
      content: lazyLoad("supplier-note"),
    },
  },
  {
    path: "/supplier-note/review/:id",
    name: "supplier-note-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "SupplierNote",
    },
    components: {
      content: lazyLoad("supplier-note"),
    },
  },
  {
    path: "/supplier-note/edit/:id",
    name: "supplier-note-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "SupplierNote",
    },
    components: {
      content: lazyLoad("supplier-note"),
    },
  },

  {
    path: "/supplier-transaction-history/:id",
    name: "supplier-transaction-history",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "SupplierTransactionHistory",
    },
    components: {
      content: lazyLoad("supplier-transaction-history"),
    },
  },

  {
    path: "/supplier-transaction",
    name: "supplier-transaction",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "SupplierTransactionHistory",
    },
    components: {
      content: lazyLoad("supplier-transaction"),
    },
  },
  {
    path: "/supplier/awaiting-payment-list",
    name: "awaiting-payment-list",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "SupplierTransactions",
    },
    components: {
      content: lazyLoad("awaiting-payment-list"),
    },
  },

  {
    path: "/supplier-batch-payment/create",
    name: "batch-payment-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "BatchPaymentSave",
    },
    components: {
      content: lazyLoad("batch-payment"),
    },
  },
  {
    path: "/supplier-batch-payment/review/:id",
    name: "batch-payment-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "BatchPaymentSave",
    },
    components: {
      content: lazyLoad("batch-payment"),
    },
  },
  {
    path: "/supplier-batch-payment/edit/:id",
    name: "batch-payment-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "BatchPaymentCommit",
    },
    components: {
      content: lazyLoad("batch-payment"),
    },
  },

  {
    path: "/supplier/batch-payment-list",
    name: "batch-payment-list",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "BatchPaymentSave",
    },
    components: {
      content: lazyLoad("batch-payment-list"),
    },
  },

  {
    path: "/supplier-payment/review/:id",
    name: "supplier-payment-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CashPayment", // CreditCustomer
    },
    components: {
      content: lazyLoad("supplier-payment"),
    },
  },
  {
    path: "/supplier-payment/create",
    name: "supplier-payment-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CashPayment",
    },
    components: {
      content: lazyLoad("supplier-payment"),
    },
  },
  {
    path: "/supplier-payment/create/:id",
    name: "supplier-payment-create-id",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CashPayment",
    },
    components: {
      content: lazyLoad("supplier-payment"),
    },
  },
  {
    path: "/remittance-distribution/review/:id",
    name: "remittance-distribution-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "BatchPaymentSave",
    },
    components: {
      content: lazyLoad("remittance-distribution"),
    },
  },
];
